import { useState } from "react";
import { Link } from "react-router-dom";
import Spinner from "../../components/Spinner";
import { RootState } from "../../redux/rootReducers";
import { useDispatch, useSelector } from "react-redux";
import { Root, AuthenticationContainer } from "./@styles";
import { ButtonSolid } from "../../components/forms/Button";
import AuthenticationLoadingPage from "./AuthenticationLoadingPage";
import imgBackground from "../../static/images/tim-marshall-unsplash.jpg";
import { authenticateAsync } from "../../redux/reducers/authorization/authorization.actions";


interface formData {
  email: string;
  password: string;
};

const AuthenticationLoginPage = () => {
  const dispatch = useDispatch();

  const error = useSelector((state: RootState) => state.authorization.error);
  const isLoading = useSelector((state: RootState) => state.authorization.isLoading);

  const [formData, setFormData] = useState<formData>({
    email: "",
    password: "",
  });

  const onTextChange = (field: keyof typeof formData, value: string) => {
    setFormData({ ...formData, [field]: value });
  };

  const attemptLogin = () => {
    const { email, password }  = formData;
    dispatch(authenticateAsync.request({ email, password }));
  };

  const renderButtonLogin = () => {
    if (isLoading) {
      return (
        <ButtonSolid type="button" secondary>
          <span className="icon">
            <Spinner size="small" />
          </span>
          Memproses autentikasi
        </ButtonSolid>
      );
    } else {
      return (
        <ButtonSolid type="submit" secondary onClick={attemptLogin}>
          Masuk
        </ButtonSolid>
      );
    }
  }

  return (
    <Root>
      <AuthenticationContainer className={`${isLoading ? '' : 'show'}`}>
        <div className="auth--form">
          <div className="auth--form--bg">
            <div className="auth--form--content">
              <div className="auth--form--content--logo">
                {/* <img src={imgLogo} alt="Candyd" /> */}
              </div>
              <div className="auth--form--content--form">
                <div className="auth--form--content--form--title">
                  <h3>Selamat Datang,</h3>
                  <p>
                    Masukan alamat email dan kata sandi Anda untuk masuk. Apabila Anda belum mendaftar, silahkan <a href="#">menghubungi sekretariat</a>.
                  </p>
                </div>
                <div className={`auth--form--content--form--input ${isLoading ? 'disabled' : ''}`}>
                  <label>Alamat Email</label>
                  <input
                    type="text"
                    name="email"
                    disabled={isLoading}
                    value={formData.email}
                    onChange={(e) => onTextChange("email", e.target.value)}
                    placeholder="Masukkan email Anda disini"
                  />
                </div>
                <div className={`auth--form--content--form--input ${isLoading ? 'disabled' : ''}`}>
                  <label>Kata Sandi</label>
                  <input
                    type="password"
                    name="password"
                    disabled={isLoading}
                    value={formData.password}
                    onChange={(e) => onTextChange("password", e.target.value)}
                    placeholder="Masukkan kata sandi Anda disini"
                  />
                </div>
                { error ? (
                  <div className="auth--form--content--form-error">
                    #{ error?.status } — { error?.message }
                  </div>
                ) : null}
                <div className="auth--form--content--form--button">
                  {renderButtonLogin()}
                  <Link to="/forgot-password">Lupa kata sandi?</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="auth--info" >
          <img src={imgBackground} alt="" />
          <div className="auth--info--content">
            <AuthenticationLoadingPage />
          </div>
        </div>
      </AuthenticationContainer>
    </Root>
  );
};

export default AuthenticationLoginPage;